import { render, staticRenderFns } from "./OfficeDelete.vue?vue&type=template&id=25b9dc0c&scoped=true&"
import script from "./OfficeDelete.vue?vue&type=script&lang=js&"
export * from "./OfficeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b9dc0c",
  null
  
)

export default component.exports